import lazyLoad from 'app/shared-components/util/lazyLoad';

const AccountApp = lazyLoad(() => import('./AccountApp'));

const AccountAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  helpConfig: {
    query: 'account',
    tag: 'account',
    title: 'Account'
  },
  routes: [
    {
      path: 'apps/account',
      element: <AccountApp />,
    },
    {
      path: 'apps/account/security',
      element: <AccountApp />,
    },
    {
      path: 'apps/account/identity',
      element: <AccountApp />,
    },
    {
      path: 'apps/account/general',
      element: <AccountApp />,
    },
    {
      path: 'apps/account/communication',
      element: <AccountApp />,
    },
    {
      path: 'apps/account/usage',
      element: <AccountApp />,
    },
    {
      path: 'apps/account/addons',
      element: <AccountApp />,
    },
    {
      path: 'apps/account/payments',
      element: <AccountApp />,
      helpConfig: {
        query: 'payments billing',
        title: 'Payments'
      },
    },
  ],
};

export default AccountAppConfig;
